import SearchPage from './containers/SearchPage';
import FilterPanel from './containers/FilterPanel';
import {
    FILTER_BREAKPOINT,
    FILTER_ANIMATION_SECONDS,
} from './utils/constants';

export default SearchPage;

export {
    FilterPanel,
    FILTER_BREAKPOINT,
    FILTER_ANIMATION_SECONDS,
};
